module.exports = new __parcel__URL__("posterama.bfc7ff2d.png").toString();